import { DateTime } from "luxon";
import { AppDispatch } from "../../../app/store";
import { initBookingTime } from "../../../components/BookingForm/functions/date-time.functions";
import { getBookingType } from "../../../components/BookingForm/utils/booking.utils";
import { clearFloors, clearInputs, setInputs } from "../../Booking-Form/slices/booking.slice";
import { BookingType, Frequence } from "../../Booking-Form/typings/booking-inputs";
import { defaultRecurrenceWeekdays } from "../../Booking-Form/typings/shared/weekdays";

export type VisitorBookingFormBooker = {
  sub: string;
  firstName: string;
  surname: string;
  email: string;
};

/**
 * Clears booking wizard state and primes Redux for a new **visitor** booking (visitor registration step next),
 * matching the payload set when the user picks Visitor on the mode selection screen.
 */
export function resetBookingFormForNewVisitorBooking(
  dispatch: AppDispatch,
  booker: VisitorBookingFormBooker
): void {
  dispatch(clearInputs());
  dispatch(clearFloors());
  dispatch(
    setInputs({
      mode: BookingType.VISITOR,
      bookingType: getBookingType(BookingType.VISITOR),
      usersBookedFor: [
        {
          userId: booker.sub,
          firstName: booker.firstName,
          surname: booker.surname,
          isExternal: false,
          email: booker.email
        }
      ],
      isUserBookedBy: true,
      automatedSeating: false,
      userBookedBy: booker.email,
      userBookedById: booker.sub,
      isExternal: false
    })
  );
}

/** Default date/time for the visitor-admin “new booking” dialog (tenant timezone, same idea as {@link FormDateTime}). */
export function primeVisitorAdminNewBookingDateInputs(
  dispatch: AppDispatch,
  opts: {
    standardEndTime: string;
    standardStartTime: string;
    timezone: string;
  }
): void {
  const today = DateTime.now().setZone(opts.timezone).toISODate() ?? "";
  const [bookingStart, bookingEnd] = initBookingTime(
    opts.standardStartTime,
    opts.standardEndTime,
    BookingType.VISITOR
  );
  dispatch(
    setInputs({
      timezone: opts.timezone,
      bookingFrom: today,
      bookingTo: today,
      bookingStart,
      bookingEnd,
      specificDays: [today],
      frequence: Frequence.SINGLE,
      weekdays: defaultRecurrenceWeekdays,
      timeSpanBigEnough: true,
      booked: false,
      errorConfirm: undefined
    })
  );
}
